var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.isPoliciesRoute)?_c('router-view'):(_vm.underMaintenance)?_c('Maintenance'):(_vm.isLoggedIn && !_vm.$getActive() && !(_vm.isRoot || _vm.isSupport || _vm.isReSeller))?_c('ActivationPayment'):(_vm.isLoggedIn)?_c('router-view'):_c('Login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }